import React from 'react'
import { hasAvailableAction } from '../../../ui/gov-actions'
import DefaultForm from '../../../ui/forms/default-form'
import { WithdrawSessionReportFields, WithdrawSessionReportDone } from './fields'

const available = record => hasAvailableAction(record, 'withdraw_session')

const submitEndPoint = ({ record, service_id, service_type }) =>
  [
    process.env.REACT_APP_API_HOST,
    'api',
    service_type,
    service_id,
    'session-reports',
    record.id,
    'withdraw',
  ].join('/')

const formValue = 'withdraw_session'
const formLabel = 'Withdraw Session Report'

const withdrawSessionReportForm = ({ url }) => ({ handleSuccess }) => (
  <DefaultForm
    url={url}
    value={formValue}
    label={formLabel}
    formComponent={WithdrawSessionReportFields}
    loadingTitle="Withdrawing Session Report..."
    handleSuccess={() => handleSuccess({ [formValue]: <WithdrawSessionReportDone /> }, formValue)}
  />
)

export const withdrawSessionReport = ({ service_id, service_type, record, refresh_reports }) =>
  available(record)
    ? {
        label: formLabel,
        value: formValue,
        actionForm: withdrawSessionReportForm({
          url: submitEndPoint({ record, service_id, service_type }),
        }),
        onComplete: refresh_reports,
      }
    : null



// WEBPACK FOOTER //
// ./src/session-summaries/details/withdraw-session-report/index.js